




































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import {GetTenantInfo,GetSelectListByTenantId,PatientListByMachineData} from '../../api/realTime'
@Component({
  components:{}
})
export default class extends AbpBase{
    tenantId = null
    status = 2
    area = null
    shift = null
    tenantOptions = []
    statusOptions = [
        {value:1,text:'透析中'},
        {value:2,text:'透析下机'},
    ]
    areaOptions = []
    shiftOptions = []
    list  = []
    //获取下拉框
    async getSelects(){
        this.tenantOptions = (await GetTenantInfo({})).data
        //默认选择第一条
        this.tenantId = this.tenantOptions[0].tenantId
        let res = await GetSelectListByTenantId({TenantId:this.tenantId})
        this.shiftOptions = res.data.sickbedShifts
        this.shift = this.shiftOptions[0].number
        this.areaOptions = [{id:null,code:'全部'},...res.data.sickbedAreas]
    }
    async tenantChange(){
        this.area = null
        let res = await GetSelectListByTenantId({TenantId:this.tenantId})
        this.shiftOptions = res.data.sickbedShifts
        this.shift = this.shiftOptions[0].number
        this.areaOptions = [{id:null,code:'全部'},...res.data.sickbedAreas]
        this.getData()
    }
    async created() {
        await this.getSelects()   
        this.getData()
    }
    detail(row:any){
        row.shiftName = this.shiftOptions.find((v:any)=>{return v.number==this.shift}).name
        row.areaName = this.areaOptions.find((v:any)=>{return v.id==this.area}).code
        row.statusName = this.statusOptions.find((v:any)=>{return v.value==this.status}).text
        this.$emit('getDetail',row,this.tenantId)
    }
    async getData(){
        let res = await PatientListByMachineData({
            tenantId:this.tenantId,
            shiftNumber:this.shift,
            sickAreaId:this.area,
            lastStep:this.status,
        })
        this.list = res.data
        console.log(res)
    }
}
